import { instance } from '@app/api/axios';
import { useShowToaster } from '@shared/ui/messages/useToaster';
import { useRequestError } from '@app/api/useRequestError';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMyUsers } from '@app/store/slices/myUsersSlice';
import { fetchGroupById } from '@app/store/slices/groupIdSlice';
import { fetchMyTeam } from '@app/store/slices/myTeamSlice';

export function useMembers() {
  const showToaster = useShowToaster();
  const handleRequestError = useRequestError();
  const dispatch = useDispatch();
  const { group } = useSelector((state) => state.group_id);
  const { activeTab } = useSelector((state) => state.my_team);

  const refreshMembers = () => {
    if (group?.id) {
      dispatch(fetchGroupById());
    } else if (activeTab === 'teams') {
      dispatch(fetchMyTeam());
    } else {
      dispatch(fetchMyUsers());
    }
  };

  const deleteMember = async (data) => {
    try {
      const res = await instance.post('/delete_user', data);
      showToaster('success', res?.data?.message);
      refreshMembers();
      return true;
    } catch (err) {
      showToaster('error', err?.response?.data?.message);
      throw err;
    }
  };

  const editMember = async (data) => {
    try {
      const res = await instance.post('/edit_user', data);
      showToaster('success', res?.data?.message);
      refreshMembers();
      return res?.data?.data;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  const freezeMember = async (data) => {
    try {
      const res = await instance.post('/freeze_user', data);
      showToaster('success', res?.data?.message);
      refreshMembers();
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  const inviteMember = async (data) => {
    try {
      const res = await instance.post('/create_user', data);
      refreshMembers();
      return res.data?.data;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  const leadToMember = async (data) => {
    try {
      const res = await instance.post('/change_role/lead_to_member', data);
      showToaster('success', res?.data?.message);
      refreshMembers();
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  const memberToLead = async (data) => {
    try {
      const res = await instance.post('/change_role/member_to_lead', data);
      showToaster('success', res?.data?.message);
      refreshMembers();
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  const moveMember = async (data) => {
    try {
      const res = await instance.post('/move_member', data);
      showToaster('success', res?.data?.message);
      refreshMembers();
      return true;
    } catch (err) {
      return handleRequestError(err);
    }
  };

  const unfreezeMember = async (data) => {
    try {
      const res = await instance.post('/unfreeze_user', data);
      showToaster('success', res?.data?.message);
      refreshMembers();
      return true;
    } catch (err) {
      showToaster('error', err?.response?.data?.message);
      throw err;
    }
  };

  return {
    deleteMember,
    editMember,
    freezeMember,
    inviteMember,
    leadToMember,
    memberToLead,
    moveMember,
    unfreezeMember,
  };
}
